import React from "react";
import { Modal, Button } from "react-bootstrap";

const AssignConfirmationModal = ({ show, close, onConfirm }) => {
    return (
        <Modal
            show={show}
            onHide={close}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Confirm Assign Planner
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                Are you sure you want to assign this planner?
            </Modal.Body>

            <Modal.Footer>
                <Button
                    className="activeBtn"
                    onClick={onConfirm}
                >
                    Submit
                </Button>

            </Modal.Footer>
        </Modal>
    );
};

export default AssignConfirmationModal;